import { useEffect } from 'react';

import { connectBoardWebsocket } from '@walls/services/boardWebsockets';
import type { WallBoard } from '@walls/store';

export function useBoardWebsocket(board: WallBoard | null) {
  const boardId = board?.id;

  useEffect(() => {
    if (!boardId) {
      return undefined;
    }

    return connectBoardWebsocket(boardId);
  }, [boardId]);
}
